module.exports = __webpack_public_path__ + "media/images/common/nav_2-46cd2574aabff3deb89c3321d5462584.png";